import React from 'react';
import { PRODUCT_NAME, SUPPORT_EMAIL } from '../data/content';
export function Footer() {
  return <footer className="border-t border-white/10 bg-brand-ink pb-16" data-id="element-78" data-mp="3gfivmltl4hfp">
      <div className="mx-auto max-w-xl px-3 py-4 text-center sm:px-5" data-id="element-79" data-mp="32nul2myzi10u">
        <p className="text-xs leading-snug text-white/60" data-id="element-80" data-mp="32pp4txyirn3c">
          © 2026 — Todos los Derechos Reservados.
        </p>
        <p className="mt-1 text-xs leading-snug text-white/60" data-id="element-81" data-mp="36n3bbhutfgrn">
          {PRODUCT_NAME} es un producto educativo de apoyo para la enseñanza del
          inglés en primaria. No sustituye formación docente, títulos
          habilitantes, diseños curriculares oficiales ni el criterio
          pedagógico de un profesional. Las actividades deben adaptarse a la
          edad, nivel y necesidades de los alumnos.
        </p>
        <p className="mt-1.5 text-xs text-white/80" data-id="element-82" data-mp="29ynldknsn5e0">
          Soporte:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-brand-yellow transition-colors duration-150 ease-out hover:text-white" data-id="element-83" data-mp="2ey9yzv7jannc">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <nav aria-label="Enlaces legales" className="mt-1.5 flex flex-wrap items-center justify-center gap-x-1.5 gap-y-1 text-xs text-white/80" data-id="element-84" data-mp="3gbin2t0cjq2c">
          <a href="#terminos" className="transition-colors duration-150 ease-out hover:text-brand-yellow" data-id="element-85" data-mp="3q8wq9qx9eicp">
            Términos y Condiciones
          </a>
          <span className="text-white/40" data-id="element-86" data-mp="33xge4qruavo">•</span>
          <a href="#privacidad" className="transition-colors duration-150 ease-out hover:text-brand-yellow" data-id="element-87" data-mp="335ph784d1bq">
            Política de Privacidad
          </a>
          <span className="text-white/40" data-id="element-88" data-mp="cv1s8vl5hfma">•</span>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="transition-colors duration-150 ease-out hover:text-brand-yellow" data-id="element-89" data-mp="qthyymj0j64f">
            Contacto
          </a>
        </nav>
      </div>
    </footer>;
}